import React from 'react';
import _ from 'lodash';

import { CcusTable } from './tables/CcusTable';
import { FormListSubHeader } from './CommonFormComponents';

const columns = [
  {
    name: 'CCUS管理者ID',
    classname: 'col-25',
  },
  {
    name: '表示名',
    classname: 'col-25',
  },
  {
    name: '連携ユーザー数',
    classname: 'col-25',
  },
  {
    name: '',
    classname: 'col-25',
  },
];

export const CcusListAddition = ({
  data,
  createAdmin,
  editAdmin,
  editUser,
}) => {
  return (
    <div className='multi-table ccus-multi-table'>
      <FormListSubHeader
        title='その他の管理者情報'
        info='※登録は必須ではありません'
      />
      <div className='text-description'>
        登録責任者以外のログインIDを設定することもできます。
      </div>
      <div className='multi-table__table'>
        {!_.isEmpty(data) && (
          <CcusTable
            data={data}
            columns={columns}
            tableType='admin'
            editAdmin={editAdmin}
            editUser={editUser}
          />
        )}
        <button className='btn--sub' onClick={createAdmin}>
          CCUS管理者ID追加
        </button>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/CcusListAddition.jsx